const INFO = {
	main: {
		title: "Reactfolio by Davi",
		name: "Davi S.",
		email: "davisena145@gmail.com",
		logo: "../logo2.jpg",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/",
		linkedin: "https://linkedin.com/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Self-entitled epistemophiliac polymath",
		description:
			"Hello. It's a pleasure to get to know you. This is my personal website, where I talk a bit about who I am. My name is Davi Cavalcanti Sena, I was born in Recife, Brazil at June 20, 2000. When I was younger I would spend most of my time studying mathematics for the national olympiad where I ranked well a couple of times. Due to my performance at these math olympiads I was able to study Computer Science and Mathematics at the University of Waterloo, where I gradudated at June 2023. During my university I was very undecisive of what I should do about my career, initially I wanted to be a mathematician or a quant, but I ended up deciding to become a software engineer to pay the bills. I still have hopes of doing something meaningful in my career but that hasn't happened yet. On my personal life, I enjoy studying anything really. I doesn't matter if it's philosophy or anthropology, I really like to use my imagination and understanding the core concepts of the reality that behold us.",
	},

	about: {
		title: "I’m Davi Cavalcanti Sena, I live in Vancouver.",
		description:
			"Self-entitled epistemophiliac polymath. Wants to aquire the basics all of human knowledge before he dies.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Project 1",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 2",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 3",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 4",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 5",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},
	],
};

export default INFO;
